import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DownloadSMimeCertificateByLabelState {
  isLoading: boolean
  loadingError: string | null
  downloadSMimeCertificate: any
}
const initialState: DownloadSMimeCertificateByLabelState = {
  isLoading: true,
  loadingError: null,
  downloadSMimeCertificate: null
}

export const exportSMimeCertificate = createSlice({
  name: 'exportSMimeCertificate',
  initialState,
  reducers: {
    exportSMimeCertificateLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        downloadSMimeCertificate: []
      }
    },
    exportSMimeCertificateUpdateAction: (state, action: PayloadAction< any >) => {
      return {
        isLoading: false,
        loadingError: null,
        downloadSMimeCertificate: action.payload
      }
    },
    exportSMimeCertificateErrorAction: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        downloadSMimeCertificate: null
      }
    }
  }
})

export const {
  exportSMimeCertificateLoadingAction,
  exportSMimeCertificateUpdateAction,
  exportSMimeCertificateErrorAction
} = exportSMimeCertificate.actions

export default exportSMimeCertificate.reducer
